import { isEmpty, rest } from 'lodash';
import React from 'react'
import { Button, Image } from 'react-bootstrap';
import { useSelector } from 'react-redux';

const TopRightBar = ({ ...rest }) => {

  const session = useSelector(state => state.session);
  const themeState = useSelector(state => state.themeState);

  return (
    <>
      <div className='top-right-bar d-flex'>
        {/*<Button variant='none' className='rounded-circle d-flex align-items-center justify-content-center me-1'>
          <Image
            src={themeState.themeMode === 'dark' ? '/assets/images/top-right-notification-dark.svg' : '/assets/images/top-right-nofication.svg'}
          />
        </Button>*/}
        <div className='d-flex align-items-center'>
          <Image src='/assets/images/top-right-john.png' className='me-1' />
          <p className='font-13 font-weight-normal user-name'>{!isEmpty(session.user) ? session.user.name : ''}</p>
        </div>
      </div>
    </>
  )
}

export default TopRightBar
